import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faPhone } from "@fortawesome/free-solid-svg-icons";

function NotFound() {
  return (
    <div className="notfound-page">
      <Navbar />
      <section
        className="hr-section hr-center"
        style={{ paddingTop: "160px", minHeight: "60vh" }}
      >
        <div className="hr-container">
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(4rem, 12vw, 7rem)",
              fontWeight: 700,
              color: "var(--teal)",
              lineHeight: 1,
            }}
          >
            404
          </div>
          <h1 className="hr-heading" style={{ marginTop: "10px" }}>
            Page Not Found
          </h1>
          <p className="hr-subheading" style={{ margin: "16px auto 30px" }}>
            The page you are looking for doesn’t exist or has moved. Let’s get
            you back to caring hands.
          </p>
          <div className="cta-actions">
            <Link to="/" className="hr-btn hr-btn-secondary">
              <FontAwesomeIcon icon={faHouse} /> Back to Home
            </Link>
            <a href="tel:2535230098" className="hr-btn hr-btn-ghost">
              <FontAwesomeIcon icon={faPhone} /> 253-523-0098
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default NotFound;
